import React, { memo, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './AnimatedRoute.module.scss';

export const AnimatedRoute = memo(({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const [animationClass, setAnimationClass] = useState('');
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    setAnimationClass(styles.routeSlideIn);
    const timer = setTimeout(() => setAnimationClass(''), 1000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return <div className={animationClass}>{children}</div>;
});
AnimatedRoute.displayName = 'AnimatedRoute';
